export const AUTO_STOP_DISABLED_MINUTES = 0;
export const DEFAULT_AUTO_STOP_MINUTES = 10;
export const MIN_AUTO_STOP_MINUTES = 10;
export const MAX_AUTO_STOP_MINUTES = 360;

export const DEFAULT_MAINTENANCE_WINDOW_HOUR_OF_DAY = 0;
export const DEFAULT_MAINTENANCE_WINDOW_DAY_OF_WEEK = 0;
export const DEFAULT_MAINTENANCE_WINDOW_INTERVAL_WEEKS = 4;
